import {
  Flex,
  Container,
  Heading,
  Stack,
  Text,
  Image,
  Link,
  HStack,
  useColorModeValue,
} from '@chakra-ui/react'
import HeroSvg from '../assets/hero.svg'
import { BuiltWith, DappHighlight, Subscribe } from '../components'
import { DappProps } from '../components/DappHighlight'

export default function Home() {
  const dapps: Array<DappProps> = [
    {
      name: 'Token Transfer 💸',
      description: 'Transfer Matic Tokens to any Address on the Mumbai Testnet',
      link: '/tokentransfer',
    },
    {
      name: 'Bill Board 🖼️',
      description: 'Store and Retrieve Data from the Blockchain',
      link: '/simplestorage',
    },
    {
      name: 'Task Manager ✅',
      description: 'Create, Update and Manage Tasks with Smart Contract',
      link: '/taskmanage',
    },
    {
      name: 'Poll in the Wall 🧱',
      description: 'Share your opinion on the future of web3',
      link: '/poll',
    },
    {
      name: 'Web3 Cloud ☁️',
      description: 'Hassle-free File Uploads to IPFS Decentralized Storage Platform',
      link: '/ipfs-upload',
    },
    {
      name: 'RPS ✊✋✌️',
      description: 'Fair and Decentralized Rock Paper Scissors on Blockchain',
      link: '/rps',
    },
    {
      name: 'Tic Tac Toe ✖️⭕',
      description: 'Tic Tac Toe for all the Web3 Enthusiasts',
      link: '/tictactoe',
    },
    {
      name: 'Inscriptions 🙉',
      description: 'Create your NFT inscription on Mumbai Testnet',
      link: '/inscription',
    },
    {
      name: 'Split_Pay ✂️',
      description: 'Decentralised Payment Splitter for every project',
      link: '/inscription',
    },
  ]
  const devTools: Array<DappProps> = [
    {
      name: 'Geth Cmds 🖥️',
      description: 'Geth Commands for Private Blockchain creation',
      link: '/geth-commands',
    },
    {
      name: 'Valid_Eth ✔️',
      description: 'Filters Valid Eth Addresses from Others',
      link: '/valid-eth',
    },
    {
      name: 'Count My NFTs 🔢',
      description: 'Find the right trait size for your NFT collection',
      link: '/count-my-nft',
    },
  ]
  const genAi: Array<DappProps> = [
    {
      name: 'PlotGen.AI 🤖',
      description: 'Describe in few words to generate a movie plot & more',
      link: '/plotgen',
    },
  ]

  return (
    <Container maxW={'5xl'} bg={'gray.50'}>
      <Stack textAlign={'center'} align={'center'} spacing={{ base: 8, xl: 10 }} py={{ base: 20 }}>
        <Heading
          fontWeight={600}
          fontSize={{ base: '3xl', xl: '5xl' }}
          lineHeight={'110%'}
          color={'second.500'}
        >
          Web3 Dapps{' '}
          <Text as={'span'} color={'brand.500'}>
            made easy
          </Text>
        </Heading>
        <Text color={'gray.500'} w={{ base: 'sm', md: 'md' }}>
          Tons of Dapps crafted with passion. Visualize the Smart Contracts you build and learn to
          be part of the revolution.
        </Text>
        {/* <Heading color={'second.500'} fontSize={{ base: 'xl' }}>
          Application is Under Development
        </Heading> */}
        <Flex alignItems={'center'} justifyContent={'center'}>
          <Image src={HeroSvg} boxSize={{ base: 'sm', xl: 'sm' }} />
        </Flex>
      </Stack>
      <Stack
        align={'center'}
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}
        wrap={'wrap'}
      >
        <Heading fontSize={{ base: '2xl', md: '4xl' }} color={'second.500'}>
          Web3 Dapps
        </Heading>
        <Flex justifyContent={'space-evenly'} wrap={'wrap'} w={'full'}>
          {dapps.map((app) => (
            <DappHighlight
              key={app.name}
              description={app.description}
              name={app.name}
              link={app.link}
            />
          ))}
        </Flex>
      </Stack>
      <Stack
        align={'center'}
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}
        wrap={'wrap'}
        my={12}
      >
        <Heading fontSize={{ base: '2xl', md: '4xl' }} color={'brand.500'}>
          Web3 Dev Tools
        </Heading>
        <Flex justifyContent={'space-evenly'} wrap={'wrap'} w={'full'}>
          {devTools.map((app) => (
            <DappHighlight
              key={app.name}
              description={app.description}
              name={app.name}
              link={app.link}
            />
          ))}
        </Flex>
      </Stack>
      <Stack
        align={'center'}
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}
        wrap={'wrap'}
      >
        <Heading fontSize={{ base: '2xl', md: '4xl' }} color={'second.500'}>
          Generative AI
        </Heading>
        <Flex justifyContent={'space-evenly'} wrap={'wrap'} w={'full'}>
          {genAi.map((app) => (
            <DappHighlight
              key={app.name}
              description={app.description}
              name={app.name}
              link={app.link}
            />
          ))}
        </Flex>
      </Stack>

      <BuiltWith />
      <Subscribe />
    </Container>
  )
}
